import React, { useState, useEffect } from 'react';
import { getAgentConfig } from '../../services/adminApi';
import { notify } from '../../utils/notify';
import './Settings.css';

function AgentSettings() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      setLoading(true);
      const response = await getAgentConfig();
      setConfig(response.data);
    } catch (err) {
      console.error('Failed to load agent config:', err);
      notify.error('Failed to load agent configuration');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="settings-loading">Loading agent configuration...</div>;
  }

  if (!config) {
    return <div className="settings-error">Failed to load configuration</div>;
  }

  return (
    <div className="settings-page">
      <h2>AI Agent Configuration</h2>
      <p className="settings-note">
        Note: Configuration is read-only. To modify settings, update environment variables and restart the application.
      </p>

      <div className="settings-section">
        <h3>Customer Care Agent</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>Qdrant URL</label>
            <div className="config-value">{config.customer_care.qdrant_url}</div>
          </div>
          <div className="config-item">
            <label>Collection Name</label>
            <div className="config-value">{config.customer_care.collection_name}</div>
          </div>
          <div className="config-item">
            <label>Primary LLM</label>
            <div className="config-value">{config.customer_care.primary_llm}</div>
          </div>
          <div className="config-item">
            <label>Fallback LLM</label>
            <div className="config-value">{config.customer_care.fallback_llm || 'Not configured'}</div>
          </div>
          <div className="config-item">
            <label>Embedding Model</label>
            <div className="config-value">{config.customer_care.embedding_model}</div>
          </div>
          <div className="config-item">
            <label>Embedding Dimensions</label>
            <div className="config-value">{config.customer_care.embedding_dimensions}</div>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>Tutor/Networker Agent</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>Qdrant URL</label>
            <div className="config-value">{config.tutor.qdrant_url}</div>
          </div>
          <div className="config-item">
            <label>Collection Name</label>
            <div className="config-value">{config.tutor.collection_name}</div>
          </div>
          <div className="config-item">
            <label>Primary LLM</label>
            <div className="config-value">{config.tutor.primary_llm}</div>
          </div>
          <div className="config-item">
            <label>Fallback LLM</label>
            <div className="config-value">{config.tutor.fallback_llm || 'Not configured'}</div>
          </div>
          <div className="config-item">
            <label>Embedding Model</label>
            <div className="config-value">{config.tutor.embedding_model}</div>
          </div>
          <div className="config-item">
            <label>Embedding Dimensions</label>
            <div className="config-value">{config.tutor.embedding_dimensions}</div>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>Escalation Settings</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>SLA (Minutes)</label>
            <div className="config-value">{config.escalation.sla_minutes} minutes</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentSettings;

